import ToyotaLexusLogo from '@assets/logos/toyota-lexus.svg'
import ToyotaProfessional from '@assets/logos/toyota-professional.svg'
import { useBrand } from '@contexts/useBrand'

import Title from './title'

type Props = {
  title: string
  businessName: string
}

const CustomLogoNav = ({ title, businessName }: Props) => {
  const brand = useBrand()

  return (
    <header
      className={`bg-primary p-6 lg:p-10 ${brand === 'lexus' && ' uppercase'}`}
    >
      <div className="container flex flex-col gap-6">
        {businessName === 'toyota-lexus' && <ToyotaLexusLogo width="185" />}
        {businessName === 'toyota-professional' && (
          <ToyotaProfessional width="215" />
        )}
        <Title className="!ml-0">{title}</Title>
      </div>
    </header>
  )
}

export default CustomLogoNav
